import PropTypes from 'prop-types';
export const bottomBarPropTypes = {
  // icons: PropTypes.shape({
  //   shipping: PropTypes.shape({
  //     inPostPaczkomaty: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     inPostKurier: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     })
  //   }),
  //   payment: PropTypes.shape({
  //     mastercard: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     visa: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     americanExpress: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     przelewy24: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     blik: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     payPo: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     googlePay: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     }),
  //     applePay: PropTypes.shape({
  //       visible: PropTypes.bool,
  //       title: PropTypes.string
  //     })
  //   })
  // }),
  icons: PropTypes.any,
  interlinks: PropTypes.string,
  copyright: PropTypes.string
};